import React, {useContext, useEffect, useState, useMemo} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleLeft, faAngleRight} from "@fortawesome/free-solid-svg-icons";
import {DoorContext} from "controllers/DoorController";
import {DropdownMenuStructure, MenuContext} from "../index";
import DropdownMenu from "./DropdownMenu";

export default function DropdownMenuContentDividerDesign() {
    const {doorParameters, setDoorParameters} = useContext(DoorContext);
    const {isMenuOpen, setMenuOpen} = useContext(MenuContext);

    const [isNextButtonVisible, setIsNextButtonVisible] = useState(true);
    const [isPrevButtonVisible, setIsPrevButtonVisible] = useState(true);

    const [dividerDesignsOnDisplay, setDividerDesignsOnDisplay] = useState([]);

    const generateDividerDesignOnDisplay = useMemo(() => {
        return (targetId, indexIncrement = 0) => {
            let dividerDesigns = [];

            let index = 0;
            let targetFound = false;

            while (dividerDesigns.length !== 3) {
                let currentIndex = index % doorParameters.dividerDesigns.length;

                if (doorParameters.dividerDesigns[currentIndex].id === targetId && !targetFound) {
                    targetFound = true;
                    index += indexIncrement;

                    if (index < 0) {
                        index = doorParameters.dividerDesigns.length - 1;
                    }

                    if(indexIncrement===0){
                        if(currentIndex<3) index=0;
                        else index -= 2;
                    }

                    currentIndex = index % doorParameters.dividerDesigns.length;
                }

                if (targetFound) {
                    dividerDesigns.push(doorParameters.dividerDesigns[currentIndex]);
                }

                index++;
            }

            setDividerDesignsOnDisplay(dividerDesigns);
        }
    }, [])

    useEffect(() => {
        generateDividerDesignOnDisplay(doorParameters.getActiveDividerDesignOption().id);
    }, []);

    useEffect(() => {
        if (dividerDesignsOnDisplay.length === 0) return;

        setIsNextButtonVisible(dividerDesignsOnDisplay.slice(-1)[0].id !== doorParameters.dividerDesigns.slice(-1)[0].id);
        setIsPrevButtonVisible(dividerDesignsOnDisplay[0].id !== doorParameters.dividerDesigns[0].id);
    }, [dividerDesignsOnDisplay]);

    return (
        <>
            <DropdownMenu
                title={'divider Design'}
                contentHeight={'128px'}
                isMenuOpen={isMenuOpen.dividerDesign}
                setMenuOpen={() => {
                    let dropdownMenuStructure = new DropdownMenuStructure();
                    dropdownMenuStructure.dividerDesign = !isMenuOpen.dividerDesign;
                    setMenuOpen(dropdownMenuStructure);
                }}
            >
                <div className={'h-32 bg-slidingdoorco-menu-content-500 flex'}>

                    <div className={'w-[32px] flex justify-center px-2'}>
                    <button
                        className={'flex flex-col justify-center z-10 ' + (isPrevButtonVisible ? '' : 'hidden')}
                        onClick={() => {
                            generateDividerDesignOnDisplay(dividerDesignsOnDisplay[0].id, -1);
                        }}
                    >
                        <FontAwesomeIcon icon={faAngleLeft}
                                         className={'h-8 text-slidingdoorco-menu-content-200 hover:text-black cursor-pointer'}/>
                    </button>
                    </div>

                    <div className={'flex w-full overflow-hidden gap-2 py-2'}>
                        {
                            dividerDesignsOnDisplay.map((dividerDesign) => {
                                return (
                                    <React.Fragment key={dividerDesign.id}>
                                        <button
                                            className={'flex flex-col justify-start w-1/3'}
                                            onClick={() => {
                                                let clone = doorParameters.createClone();
                                                clone.setActiveDividerDesignOption(dividerDesign.id);
                                                setDoorParameters(clone);
                                            }}
                                        >
                                            <img
                                                src={dividerDesign.icon}
                                                className={'mx-auto rounded-sm min-h-[90px] max-h-[90px]'}
                                                alt={dividerDesign.id}
                                            />
                                            <div
                                                className={
                                                    'text-center text-white text-sm w-full ' +
                                                    (
                                                        doorParameters.getActiveDividerDesignOption().id===dividerDesign.id ?
                                                            'font-bold':''
                                                    )
                                                }
                                            >
                                                {dividerDesign.name}
                                            </div>
                                        </button>
                                    </React.Fragment>
                                );
                            })
                        }
                    </div>

                    <div className={'w-[32px] flex justify-center px-2'}>
                    <button
                        className={'flex flex-col justify-center z-10 ' + (isNextButtonVisible ? '' : 'hidden')}
                        onClick={() => {
                            generateDividerDesignOnDisplay(dividerDesignsOnDisplay[0].id, 1);
                        }}
                    >
                        <FontAwesomeIcon icon={faAngleRight}
                                         className={'h-8 text-slidingdoorco-menu-content-200 hover:text-black cursor-pointer'}/>
                    </button>
                    </div>
                </div>
            </DropdownMenu>
        </>
    );
}